// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"376":"25211a4b","833":"6c3afcc3"}[chunkId] + ".chunk.css";
};